import { Component } from 'react'
import { Choice, Code, CodeableConcepts, CodeableConcept, Result } from '../helpers'
import { FaDiagnoses } from 'react-icons/fa'

import './resource.css'

class DiagnosticReport extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Condition${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.status && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.status && Code(this.props.resource.status)}</div>
                        </div>
                        <div className='Res-Icon-Big'><FaDiagnoses /></div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.category && 'Classification'}</div>
                            <div className='Res-Title'>{this.props.resource.category && CodeableConcepts(this.props.resource.category)}</div>
                        </div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.code && 'Diagnosis'}</div>
                        <div className='Res-Title'>{this.props.resource.code && CodeableConcept(this.props.resource.code)}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.conclusion && 'Conclusion'}</div>
                        <div className='Res-Title'>{this.props.resource.conclusion && this.props.resource.conclusion}</div>
                    </div>
                    {this.props.resource.conclusionCode && <div className='Res-Row'>{CodeableConcepts(this.props.resource.conclusionCode)}</div>}
                    {this.props.resource.result && <div className='Res-Row'>{Result(this.props.resource.result)}</div>}
                    <div className='Res-row'>
                        <div className='Res-Detail Res-Content-Rev'>{(this.props.resource.effectiveDateTime  || this.props.resource.effectivePeriod) && 'Effective'}</div>
                        {this.props.resource.effectiveDateTime && <div className='Res-Detail'>{Choice('DateTime', this.props.resource.effectiveDateTime)}</div>}
                        {this.props.resource.effectivePeriod && <div className='Res-Detail'>{Choice('Period', this.props.resource.effectivePeriod)}</div>}
                    </div>
                </div>
            }
        </div></div>
    }
}

export default DiagnosticReport